// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/baseModal/baseModal.scss
// module id = 103
// module chunks = 0